// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-select[data-v-b0344544] {\n  background: #d5dee5;\n  margin-top: 1rem;\n  max-width: 30rem;\n}\n.dark .v-select[data-v-b0344544] {\n  background: #585858;\n}", ""]);
// Exports
module.exports = exports;
